import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from './general/card/card.module';
import { ProgressStepsModule } from './progress-steps/progress-steps.module';
import { LikertModule } from './likert/likert.module';
import { BadgeInfoModule } from './badge-info/badge-info.module';
import { InputNumberModule } from './input-number/input-number.module';


@NgModule({
  declarations: [

  ],
  exports: [
    BadgeInfoModule,
    CardModule,
    ProgressStepsModule,
    LikertModule,
    InputNumberModule
  ],
  imports: [
    CommonModule,
    RouterModule
  ]
})
export class PartialsModule {}
